import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, getOTP } from '@/utils/auth'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import Cookies from 'js-cookie'

Vue.use(Vuex)
const auth_data = JSON.parse(localStorage.getItem('olselforder_auth_data'))
if (getToken() && auth_data !== null) {
  auth_data.access_token = getToken()
}

export default new Vuex.Store({
  state: {
    loading: false,
    loading_axios: false,
    auth_data: auth_data,
    store_data: JSON.parse(localStorage.getItem('olselforder_selected_outlet')),
    url_domain: Cookies.get('olselforder_url_domain'),
    data_cart_reservation: JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_reservation')) || [],
    customer_data: JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_customer')),
    order_data: JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_order')) || {},
    payment: JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_payment')),
    data_verification: JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_verification')),
    type_verification: localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_type_verification'),
    otp_forget_password: getOTP(),
    router_data: JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_router_data')) ?? [],
    query_router: JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_query_router')) ?? [],
    error_type: '',
    error_message: '',
    show_error: false,
  },
  getters,
  mutations,
  actions,
  modules: {
  }
})
